import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { a as addSpacingClasses, p as paddingPropTypes } from './spacing-7e57ffb0.js';
import { B as Box } from './Box-17ae6268.js';

function NumberedBox({
  children,
  counter,
  padding,
  ...otherProps
}) {
  let contentClasses = ['st_numberbox__content'];
  contentClasses = addSpacingClasses({
    padding,
    cssClasses: contentClasses
  });
  return /*#__PURE__*/React.createElement(Box, _extends({}, otherProps, {
    padding: {
      all: 'none'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "st_numberbox"
  }, /*#__PURE__*/React.createElement("div", {
    className: "st_numberbox__counter"
  }, counter || /*#__PURE__*/React.createElement("span", {
    className: "st_numberbox__autocount"
  })), /*#__PURE__*/React.createElement("div", {
    className: contentClasses.join(' ')
  }, children)));
}
NumberedBox.propTypes = {
  /* padding for box contents */
  padding: paddingPropTypes,
  /** list counter */
  counter: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
NumberedBox.defaultProps = {
  padding: null,
  counter: null
};

export { NumberedBox as N };
